import flightPackCode from "./flightPackCode"
import trainPackCode from "./trainPackCode"
import transportPackCode from "./transportPackCode"

export const transportPacks = [
    ...flightPackCode,
    ...trainPackCode,
    ...transportPackCode
]


export const nonTransportPacks = [
    "PFP",
    "PF",
    "PFPCS",
    "PFCS",
    "HS",
] 